const SECONDS_IN_MINUTE = 60;
const MINUTES_IN_HOUR = 60;
const SECONDS_IN_HOUR = SECONDS_IN_MINUTE * MINUTES_IN_HOUR;
const MILLISECONDS_IN_SECOND = 1000;

export function formatLatency(latencyMs: number): string {
    if (latencyMs < MILLISECONDS_IN_SECOND) {
        return `${Math.round(latencyMs)}ms`;
    }
    return `${(latencyMs / MILLISECONDS_IN_SECOND).toFixed(1)}s`;
}

export function formatCompactDuration(durationSeconds: number): string {
    if (durationSeconds < 1) {
        return '<1s';
    }
    const totalSeconds = Math.floor(durationSeconds);
    const hours = Math.floor(totalSeconds / SECONDS_IN_HOUR);
    const minutes = Math.floor(
        (totalSeconds % SECONDS_IN_HOUR) / SECONDS_IN_MINUTE,
    );
    const seconds = totalSeconds % SECONDS_IN_MINUTE;
    if (hours > 0) {
        return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`;
    }
    if (minutes > 0) {
        return seconds > 0 ? `${minutes}m ${seconds}s` : `${minutes}m`;
    }
    return `${seconds}s`;
}

export const formatDuration = (duration: number): string => {
    const hours = Math.floor(duration / (SECONDS_IN_MINUTE * MINUTES_IN_HOUR));
    const minutes = Math.floor(
        (duration % (SECONDS_IN_MINUTE * MINUTES_IN_HOUR)) / SECONDS_IN_MINUTE,
    );
    const seconds = Math.floor(duration % SECONDS_IN_MINUTE);

    const timeUnits = [
        { value: hours, label: 'hr' },
        { value: minutes, label: 'min' },
        { value: seconds, label: 'sec' },
    ];

    return timeUnits
        .filter((unit) => unit.value > 0)
        .map(
            (unit) => `${unit.value} ${unit.label}${unit.value > 1 ? 's' : ''}`,
        )
        .join(' ');
};

export const padZero = (value: number) => value.toString().padStart(2, '0');

export const formatEventTime = (timeInSeconds: number): string => {
    const hours = Math.floor(timeInSeconds / 3600);
    const minutes = Math.floor((timeInSeconds % 3600) / 60);
    const seconds = Math.floor(timeInSeconds % 60);
    return `${padZero(hours)}:${padZero(minutes)}:${padZero(seconds)}`;
};

export function formatVideoTime(seconds: number): string {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = Math.floor(seconds % 60);

    if (hours > 0) {
        return `${padZero(hours)}:${padZero(minutes)}:${padZero(remainingSeconds)}`;
    }

    return `${padZero(minutes)}:${padZero(remainingSeconds)}`;
}

export function delay(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

export function roundToTwoDecimals(value: number): number {
    return Math.round(value * 100) / 100;
}
